import React from "react";

function getBigSmall(num) {
    return Number(num) >= 5 ? "Big" : "Small";
}

function getColors(num) {
    num = Number(num);

    switch (num) {
        case 0:
            return ["violet", "red"];

        case 5:
            return ["violet", "green"];

        case 1:
        case 3:
        case 7:
        case 9:
            return ["green"];

        case 2:
        case 4:
        case 6:
        case 8:
            return ["red"];

        default:
            return [];
    }
}

const circleStyle = (color) => ({
    width: 14,
    height: 14,
    borderRadius: "50%",
    display: "inline-block",
    margin: "0 4px",
    backgroundColor:
        color === "green"
            ? "#18c37e"
            : color === "red"
                ? "#ff4d1a"
                : "#9c27b0"
});

const ColorGameResult = ({ resultData }) => {
    return (
        <div className="left-content">

            <div
                className="table-responsive"
                style={{
                    maxHeight: "450px",
                    overflowY: "auto"
                }}
            >

                <table
                    className="table"
                    style={{
                        marginBottom: 0,
                        color: "#fff",
                        textAlign: "center"
                    }}
                >

                    <thead
                        style={{
                            background: "#d9d9d9",
                            color: "#222"
                        }}
                    >
                        <tr>
                            <th style={{ textAlign: "left", padding: "6px 12px" }}>Period</th>
                            <th style={{ padding: "6px 12px" }}> Number</th>
                            <th style={{ padding: "6px 12px" }}>Big-Small</th>
                            <th style={{ padding: "6px 12px" }}>Color</th>
                        </tr>
                    </thead>

                    <tbody>

                        {resultData?.map((row, index) => {

                            const number = Number(row.result);
                            const colors = getColors(number);

                            return (

                                <tr
                                    key={index}
                                    style={{
                                        background: "#fff",
                                        color: "#000",
                                        fontSize: "14px"
                                    }}
                                >

                                    <td
                                        style={{
                                            textAlign: "left",
                                            padding: "6px 12px"
                                        }}
                                    >
                                        {row.period_id || row.evt_id}
                                    </td>

                                    <td>
                                        {number}
                                    </td>

                                    <td>
                                        {row.bigsmall || getBigSmall(number)}
                                    </td>

                                    <td>

                                        {colors.map((color, i) => (

                                            <span
                                                key={i}
                                                style={circleStyle(color)}
                                            />

                                        ))}

                                    </td>

                                </tr>

                            );

                        })}

                    </tbody>

                </table>

            </div>

        </div>
    );
};

export default ColorGameResult;